import '@ffdb/scss/app-front-page.scss';
import 'bootstrap/js/src/collapse';
import Utils from '@ffdb/js/services/utils';
import Slider from '@ffdb/js/services/slider';

document.addEventListener("DOMContentLoaded", function () {

	// Utils
	Utils.click();
	Utils.bootstrap();
	Utils.searchbox();
	Utils.smooth_scroll();
	Utils.lazy();
	Utils.obfuscation();
	Utils.sticky_navbar();
	Utils.flash_info_close();
	Utils.flash_info_marquee();
	Utils.burger_menu();

	// Slider
	Slider.hero();
	Slider.agenda_strate();

	// Specific
	Utils.toggle_collapse();
})
